import React from 'react'
import styled from 'styled-components'

type IllustrationProps = {
	width?: string
}

const StyledSvg = styled.svg<{ $width?: string }>`
	width: ${({ $width }) => `${$width || 'auto'}`};
	height: auto;
`

export const OsIllustration = ({
	width,
	...rest
}: IllustrationProps &
	Omit<
		React.HTMLAttributes<SVGElement>,
		'size' | 'width' | 'height' | 'color' | 'ref'
	>) => (
	<StyledSvg
		$width={width}
		xmlns='http://www.w3.org/2000/svg'
		fill='none'
		viewBox='0 0 950 501.35'
		{...rest}
	>
		<g clipPath='url(#a)'>
			<rect x={399} y={19} width={329} height={339} rx={8} fill='#DFDDE9' />
			<rect
				x={643.54}
				y={61.13}
				width={68.746}
				height={79.361}
				rx={8}
				fill='#fff'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M677.913 107.179c8.679 0 15.714-7.018 15.714-15.676 0-8.658-7.035-15.677-15.714-15.677-8.678 0-15.713 7.02-15.713 15.677 0 8.658 7.035 15.676 15.713 15.676Z'
				fill='#DFDDE9'
			/>
			<rect
				x={653.361}
				y={111.098}
				width={49.105}
				height={5.879}
				rx={2.939}
				fill='#DFDDE9'
			/>
			<rect
				x={661.218}
				y={120.896}
				width={33.391}
				height={5.879}
				rx={2.939}
				fill='#DFDDE9'
			/>
			<path
				d='M399 27a8 8 0 0 1 8-8h313a8 8 0 0 1 8 8v19H399V27Z'
				fill='#DFDDE9'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M412 37a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM424 37a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM436 37a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z'
				fill='#fff'
			/>
			<g clipPath='url(#b)'>
				<rect
					x={643.54}
					y={148.329}
					width={68.746}
					height={190.075}
					rx={8}
					fill='#fff'
				/>
				<g clipPath='url(#c)'>
					<rect
						x={661.54}
						y={166.329}
						width={33}
						height={26}
						rx={4}
						fill='#DFDDE9'
					/>
					<rect
						x={661.54}
						y={200.329}
						width={33}
						height={25}
						rx={4}
						fill='#B1ACC9'
					/>
					<rect
						x={661.54}
						y={233.329}
						width={33}
						height={25}
						rx={4}
						fill='#DFDDE9'
					/>
					<rect
						x={661.54}
						y={299.329}
						width={33}
						height={25}
						rx={4}
						fill='#DFDDE9'
					/>
					<rect
						x={661.54}
						y={266.329}
						width={33}
						height={25}
						rx={4}
						fill='#CAC5D6'
					/>
				</g>
			</g>
			<g clipPath='url(#d)'>
				<g clipPath='url(#e)'>
					<rect x={415} y={63} width={219} height={47} rx={4} fill='#fff' />
					<g clipPath='url(#f)' fill='#DFDDE9'>
						<rect x={424} y={77.1} width={161} height={7.05} rx={3} />
						<rect x={424} y={88.85} width={108.068} height={7.05} rx={3} />
					</g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 93.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z'
						fill='#DFDDE9'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 89.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
						fill='#EDEEED'
					/>
				</g>
				<g clipPath='url(#g)'>
					<rect x={415} y={118} width={219} height={39} rx={4} fill='#fff' />
					<g clipPath='url(#h)' fill='#DFDDE9'>
						<rect x={424} y={129.7} width={161} height={5.85} rx={2.925} />
						<rect x={424} y={139.45} width={108.068} height={5.85} rx={2.925} />
					</g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 144.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z'
						fill='#DFDDE9'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 140.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
						fill='#EDEEED'
					/>
				</g>
				<g clipPath='url(#i)'>
					<rect x={415} y={165} width={219} height={39} rx={4} fill='#fff' />
					<g clipPath='url(#j)' fill='#DFDDE9'>
						<rect x={424} y={176.7} width={161} height={5.85} rx={2.925} />
						<rect x={424} y={186.45} width={108.068} height={5.85} rx={2.925} />
					</g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 191.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z'
						fill='#DFDDE9'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 187.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
						fill='#B1ACC9'
					/>
				</g>
				<g clipPath='url(#k)'>
					<rect x={415} y={306} width={219} height={39} rx={4} fill='#fff' />
					<g clipPath='url(#l)' fill='#DFDDE9'>
						<rect x={424} y={317.7} width={161} height={5.85} rx={2.925} />
						<rect x={424} y={327.45} width={108.068} height={5.85} rx={2.925} />
					</g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 332.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z'
						fill='#DFDDE9'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 328.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
						fill='#EDEEED'
					/>
				</g>
				<g clipPath='url(#m)'>
					<rect x={415} y={259} width={219} height={39} rx={4} fill='#fff' />
					<g clipPath='url(#n)' fill='#DFDDE9'>
						<rect x={424} y={270.7} width={161} height={5.85} rx={2.925} />
						<rect x={424} y={280.45} width={108.068} height={5.85} rx={2.925} />
					</g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 285.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z'
						fill='#DFDDE9'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 281.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
						fill='#EDEEED'
					/>
				</g>
				<g clipPath='url(#o)'>
					<rect x={415} y={212} width={219} height={39} rx={4} fill='#fff' />
					<g clipPath='url(#p)' fill='#DFDDE9'>
						<rect x={424} y={223.7} width={161} height={5.85} rx={2.925} />
						<rect x={424} y={233.45} width={108.068} height={5.85} rx={2.925} />
					</g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 238.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z'
						fill='#DFDDE9'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M612.954 234.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
						fill='#EDEEED'
					/>
				</g>
			</g>
		</g>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M38 81c20.987 0 38-17.013 38-38S58.987 5 38 5 0 22.013 0 43s17.013 38 38 38Z'
			fill='#CAC5D6'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M38 15.038a2.15 2.15 0 1 0 0-4.302 2.15 2.15 0 0 0 0 4.302ZM7.887 45.151a2.15 2.15 0 1 0 0-4.302 2.15 2.15 0 0 0 0 4.302ZM68.113 45.151a2.15 2.15 0 1 0 0-4.302 2.15 2.15 0 0 0 0 4.302ZM38 75.264a2.15 2.15 0 1 0 0-4.302 2.15 2.15 0 0 0 0 4.302ZM38 17.189l1.434 25.094h-2.868L38 17.189ZM50.69 55.69 37.507 44.535l2.028-2.028 11.153 13.181Z'
			fill='#fff'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M38 45.868a2.868 2.868 0 1 0 0-5.736 2.868 2.868 0 0 0 0 5.736Z'
			fill='#fff'
		/>
		<path
			d='m855 161.529 13.041-14.75c3.184-3.601 8.803-3.601 11.987 0l36.959 41.803A16 16 0 0 1 921 199.18V490'
			stroke='#C7C2D5'
			strokeWidth={8}
		/>
		<rect x={891} y={489} width={59} height={7} rx={3} fill='#B1ACC9' />
		<path
			d='M819.499 153.335c12.887-12.888 33.781-12.888 46.669 0 12.887 12.887 12.887 33.781 0 46.669l-19.799 19.799-46.669-46.669 19.799-19.799Z'
			fill='#CAC5D6'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M819.228 200.527c12.887 12.887 25.392 21.277 27.931 18.738 2.538-2.538-5.851-15.043-18.739-27.93-12.887-12.888-25.392-21.277-27.93-18.739-2.539 2.539 5.851 15.044 18.738 27.931Z'
			fill='#fff'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M469.099 233.981c6.109 3.682 12.111 5.461 14.928 4.735 7.065-1.821 7.715-27.667 2.248-37.856-5.466-10.189-33.568-14.63-34.985 5.558-.492 7.006 2.45 13.259 6.797 18.362l-7.794 36.328h22.64l-3.834-27.127Z'
			fill='#B28B67'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M441.42 199.698c-.732-.725-1.13-1.759-1.475-2.741-.359-1.021-.707-2.052-.945-3.113-.475-2.122-.48-4.562 1.034-6.21 1.214-1.321 3.035-1.914 4.716-2.042a8.681 8.681 0 0 1 3.344.423c1.065.351 1.983 1.048 3.016 1.482.04-2.287.431-4.68 1.591-6.632 1.116-1.878 2.896-2.933 4.923-3.211 2.08-.287 4.134.2 5.997 1.207.466.253.928.517 1.37.816.37.25.755.552 1.189.654.484.113.724-.166 1.039-.519a7.927 7.927 0 0 1 1.224-1.103c1.945-1.429 4.497-2.017 6.75-1.16 1.039.395 2.048 1.065 2.752 1.989.628.824 1.076 2.13 1.943 2.704.367.243.627-.079.962-.318.503-.358.982-.754 1.491-1.102.715-.49 1.489-.856 2.318-1.048 1.214-.281 2.891-.215 3.238 1.374.13.597.03 1.236-.012 1.837-.058.826-.118 1.652-.19 2.477a17.762 17.762 0 0 1-.241 1.845c-.063.328-.261.939-.12 1.268.176.41.986.177 1.333.191.684.028 1.371.148 2.003.44.491.227 1.006.56 1.213 1.122.127.345.094.7.033 1.055-.072.426.011.652.065 1.082.918-.452 4.102-1.458 4.503.189.133.548-.17 1.168-.402 1.63-.407.811-.939 1.553-1.484 2.259-1.136 1.475-2.493 2.747-3.953 3.835 1.71.76 2.157 3.003.676 4.339-.653.59-1.532.721-2.357.683-.302-.014-.737-.13-.974-.077-.128.028-.265.137-.442.149-1.164.079-2.477-.201-3.615-.459-2.027-.46-3.946-1.421-5.513-2.883-.402-.376-.734-.592-1.275-.586-.475.005-.94.135-1.414.147-1.253.032-2.383-.581-3.547-.989-.071 1.573-.519 3.304-1.162 4.719-.525 1.153-1.62 1.321-2.696 1.422-3.442.324-6.896-.037-10.342-.033 3.336.755 6.783 1.065 10.089 1.953 1.495.401.353 1.408-.286 2.106-1.052 1.15-1.834 2.575-2.377 4.076-1.632-2.127-4.516-3.529-7.072-2.876-2.823.722-4.812 4.541-3.006 7.286 1.048 1.594 2.941 2.209 4.516 2.893-1.228 1.278-1.526 3.165-2.265 4.754-.365.784-.877 1.67-1.693 1.943-.301.101-.655.11-.893.356-.295.305-.366.645-.742.907-1.503 1.045-3.851.965-5.183-.399-1.205-1.233-.891-3.185.115-4.435-1.602-.668-4.52-1.526-3.883-4.022-3.471-.23-11.897-5.859-7.239-9.971-2.556-1.445-4.905-4.976-3.263-8.088 1.265-2.397 4.205-3.468 6.618-3.595'
			fill='#191847'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M409.374 379.026h72.877L491.8 496H383.317l26.057-116.974Z'
			fill='#CAC5D6'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M409.374 379.026h22.414L445.203 496h-61.886l26.057-116.974Z'
			fill='#B1ACC9'
			fillOpacity={0.8}
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M522.292 402.2c-8.19 17.369-20.986 59.53-20.986 59.53l10.864 4.964s27.565-44.32 44.411-74.616a995.812 995.812 0 0 0-2.325 22.571c-1.755 19.122-.001 60.434.943 72.368.594 7.5 10.785 5.929 11.736-.02.161-1.007.818-4.544 1.798-9.822 4.804-25.878 17.378-93.605 17.4-110.188.009-6.673-13.027-12.667-20.797-8.002-5.337-5.695-15.438-8.977-21.241.43-3.689 5.981-12.455 22.959-21.803 42.785Z'
			fill='#B28B67'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='m502.082 446.121 37.288-88.333c8.933-14.369 33.978 2.924 30.931 11.259-6.916 18.921-42.088 80.177-44.149 85.814l-24.07-8.74Z'
			fill='#A3998F'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M502.877 456.654c-.696-.942-2.037-1.167-2.932-.412-1.537 1.298-3.682 3.245-4.467 4.603-1.275 2.21-2.987 6.875-2.987 6.875l46.078 26.603s5.224-4.901 1.628-7.609c-3.597-2.707-5.936-4.567-5.936-4.567l-15.87-21.865a1 1 0 0 0-1.419-.205l-3.259 2.509s-4.547-.397-6.787-1.69c-1.333-.77-2.955-2.758-4.049-4.242ZM555.542 481.225c-1.074-.469-2.348.007-2.745 1.108-.682 1.893-1.567 4.651-1.567 6.22 0 2.552.85 7.447.85 7.447h53.206s2.074-6.856-2.395-7.403c-4.468-.547-7.423-.987-7.423-.987l-24.677-11.001a.998.998 0 0 0-1.331.532l-1.568 3.802s-4.136 1.93-6.722 1.93c-1.54 0-3.939-.911-5.628-1.648Z'
			fill='#E4E4E4'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M588.747 373.774c0 25.062-11.902 83.521-11.91 89.039l-25.607.02s5.622-78.244 3.987-79.087c-1.635-.843-67.024 6.529-86.636 6.529-28.28 0-39.978-17.834-40.928-50.87h56.021c11.407 1.221 70.904 13.221 93 17.347 9.459 1.766 12.073 10.118 12.073 17.022Z'
			fill='#DDD9D5'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='m525.145 262.702-32.743 17.933 12.091 12.978 23.792-21.784c12.533-3.454 18.265-5.981 17.195-7.581-.902-1.348-2.357-1.301-3.698-1.258-1.044.033-2.018.065-2.608-.568-1.345-1.444 1.222-6.493 3.863-11.18 2.641-4.688-.183-4.28-1.798-3.605-5.285 3.577-10.649 8.599-16.094 15.065Zm32.921 25.163-14.383 7.901.819 14.433s9.315-6.723 17.33-8.957c10.218-2.85 14.352-5.025 19.345-11.388 2.672-3.404 4.939-10.247 2.397-12.476-.976-.855-4.611 1.165-8.319 3.226-2.826 1.57-5.696 3.165-7.463 3.529-2.38.49-2.102-2.595-1.879-5.06.16-1.768.291-3.218-.61-2.799-4.21.072-7.237 11.591-7.237 11.591Z'
			fill='#997659'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M476.456 276.64c11.469-.121 26.762-2.543 43.08-12.902l6.409 14.292c-11.256 11.171-27.083 20.349-40.922 19.96-10.906-.306-16.479-13.498-8.567-21.35Z'
			fill='#294370'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M445.525 374.553c-10.903-1.422-20.922-2.728-26.859-1.559-6.661-21.634-1.13-35.255 3.976-47.829 3.078-7.578 6.001-14.777 6.007-23.119.018-24.296 19.526-61.692 22.396-61.692h26.175c1.17 15.035 6.164 31.313 11.191 47.695 1.174 3.826 2.35 7.658 3.479 11.48 19.022 4.318 61.261-10.712 61.261-10.712s10.663 22.06 9.858 31.454c-24.585 12.843-45.657 18.569-63.018 18.947.552 10.301-.702 20.103-4.914 29.059-5.643 12-29.147 8.936-49.552 6.276Z'
			fill='#6A8DC8'
		/>
		<g clipPath='url(#q)'>
			<rect x={113} y={34} width={161} height={306} rx={8} fill='#DFDDE9' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M194 330c9.389 0 17-7.387 17-16.5s-7.611-16.5-17-16.5-17 7.387-17 16.5 7.611 16.5 17 16.5ZM179.075 50.076a2.265 2.265 0 1 0 0-4.53 2.265 2.265 0 0 0 0 4.53Z'
				fill='#fff'
			/>
			<rect
				x={187.004}
				y={45.545}
				width={23.786}
				height={4.531}
				rx={2}
				fill='#fff'
			/>
			<g clipPath='url(#r)'>
				<rect x={133} y={62} width={123} height={61} rx={4} fill='#fff' />
				<g clipPath='url(#s)' fill='#DFDDE9'>
					<rect x={142} y={80.344} width={65} height={9.172} rx={3} />
					<rect x={142} y={95.631} width={43.63} height={9.172} rx={3} />
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M246 100a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z'
					fill='#DFDDE9'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M246 96a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
					fill='#F2F2F2'
				/>
				<g clipPath='url(#t)'>
					<rect
						x={133}
						y={132.206}
						width={123}
						height={48}
						rx={4}
						fill='#fff'
					/>
					<g clipPath='url(#u)' fill='#DFDDE9'>
						<rect x={172} y={146.474} width={65} height={7.134} rx={3} />
						<rect x={172} y={158.363} width={43.63} height={7.134} rx={3} />
					</g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M154 168.206c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z'
						fill='#CAC5D6'
					/>
				</g>
				<g clipPath='url(#v)'>
					<rect
						x={133}
						y={188.823}
						width={123}
						height={48}
						rx={4}
						fill='#fff'
					/>
					<g clipPath='url(#w)'>
						<rect
							x={142}
							y={203.091}
							width={65}
							height={7.134}
							rx={3}
							fill='#DFDDE9'
						/>
						<rect
							x={142}
							y={214.981}
							width={43.63}
							height={7.134}
							rx={3}
							fill='#B1ACC9'
						/>
					</g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M246 219.823a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z'
						fill='#DFDDE9'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M246 215.823a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
						fill='#F2F2F2'
					/>
				</g>
				<g clipPath='url(#x)'>
					<rect
						x={133}
						y={245.441}
						width={123}
						height={48}
						rx={4}
						fill='#fff'
					/>
					<g clipPath='url(#y)' fill='#DFDDE9'>
						<rect x={172} y={259.709} width={65} height={7.134} rx={3} />
						<rect x={172} y={271.599} width={43.63} height={7.134} rx={3} />
					</g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M154 281.441c6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12s-12 5.373-12 12c0 6.628 5.373 12 12 12Z'
						fill='#CAC5D6'
					/>
				</g>
			</g>
		</g>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M326.946 167.682c-6.43 2.877-12.527 3.9-15.201 2.849-6.705-2.637-4.228-28.071 2.357-37.409 6.585-9.339 34.662-10.314 33.618 9.662-.362 6.933-3.998 12.714-8.873 17.196l3.263 36.578-22.189-2.725 7.025-26.151Z'
			fill='#D4A181'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M328.164 123.153c2.983-.121 10.898.516 12.35.695.928.114 1.908.449 2.562-.336.536-.643.516-1.845.75-2.639.271-.922.607-1.825.945-2.724.961-2.56 2.234-4.951 3.872-7.142 3.075-4.11 7.209-7.118 12.138-8.558 5.444-1.59 11.357-1.381 16.864-.247 5.892 1.214 11.038 3.842 16.43 6.383 5.138 2.421 10.662 3.804 16.368 3.63 5.749-.175 10.389-2.713 15.505-5.034 5.238-2.377 11.045-3.638 16.75-2.484 5.326 1.078 10.009 3.909 14.091 7.424 3.818 3.288 6.841 7.051 8.201 11.993 1.463 5.315.78 10.869-3.198 14.919-5.764 5.871-15.195 6.415-22.849 5.306a42.057 42.057 0 0 1-12.698-3.978c-5.348-2.654-9.768-6.583-14.665-9.931-2.298-1.572-4.706-2.926-7.273-4.004-2.49-1.046-4.99-1.692-7.518-.419-2.674 1.347-5.087 2.696-8.041 3.382-2.834.659-5.775.86-8.661.483-5.617-.733-10.943-3.167-16.259-5.012-4.335-1.505-8.982-3.044-13.634-2.681-1.942.152-4.806.605-5.732 2.492 11.258 3.503 14.03 18.313 9.499 28.378-2.445 5.433-13.787 10.743-17.518 7.271-2.363-2.2-.485-4.476.735-5.981 2.335-2.882 3.495-6.811.15-9.428-2.885-2.257-6.707 1.793-6.768 1.78-.848-.173-7.733-5.27-12.08-12.008-5.066-.319-5.421-3.732-3.887-6.299 1.534-2.567 9.449-5.063 13.571-5.231Z'
			fill='#191847'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='m334.57 272.77-34.121 117.697-16.049 88.368h-16.108l16.08-206.065h50.198Z'
			fill='#D4A181'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M349.904 272.77c-2.38 61.143-1.441 94.492-.909 100.047.533 5.555 3.558 42.759 24.172 107.883h-16.754c-27.299-62.475-36.829-99.68-39.961-107.883-3.131-8.204-12.378-41.553-25.879-100.047h59.331Z'
			fill='#D4A181'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M335.302 272.77c-8.875 40.499-24.226 105.147-46.051 193.944h-23.56c-1.741-91.141 5.662-151.127 18.482-193.944h51.129Z'
			fill='#A3998F'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M350.023 272.77c-2.331 61.143 3.711 121.38 22.43 194.896h-25.137c-27.35-61.543-46.953-121.483-60.35-194.896h63.057Z'
			fill='#DDD9D5'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='m375.555 492.822-.847-13.67c-.039-.64-.663-1.078-1.291-.948-8.066 1.673-19.124-2.166-19.124-2.166-11.113 7.88-27.093 11.532-32.906 12.657-1.181.228-1.932 1.419-1.604 2.576l1.231 4.348H373.706l1.849-2.797ZM287.996 492.822l-.847-13.67c-.04-.64-.663-1.078-1.291-.948-8.066 1.673-19.124-2.166-19.124-2.166-11.113 7.88-27.094 11.532-32.907 12.657-1.181.228-1.931 1.419-1.604 2.576l1.232 4.348H286.147l1.849-2.797Z'
			fill='#191847'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='m254.438 172.125-29.395-22.266c-4.38-7.106-8.893-12.789-13.538-17.05-1.48-.893-4.181-1.701-2.282 3.26 1.898 4.962 3.672 10.266 2.146 11.482-1.525 1.215-4.511-1.242-6.43.869-1.279 1.407 3.956 4.707 15.705 9.899l20.083 24.729 13.711-10.923ZM368.899 272.036s-.227 54.821 1.499 60.754c.843 2.901 9.14 12.724 15.073 18.547 2.381 2.337.84 4.519-.294 4.971-9.23 3.673-13.637-3.372-20.249-7.997-7.244-5.067-8.408 5.429-14.17 1.523 2.681-3.971 8.587-11.198 7.393-16.839-.796-3.76-8.435-64.263-8.435-64.263l19.183 3.304Z'
			fill='#D4A181'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='m348.822 205.399-.967-8.115c-33.28-21.293-84.367-18.928-120.006-46.558l-7.977 11.566c25.639 58.678 88.175 56.541 128.95 43.107Z'
			fill='#8E0B10'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='m345.604 287.793-70.186-12.376c-3.208-.566-1.786-5.095-.91-7.352 10.111-26.054 36.13-51.473 42.906-89.902l20.805.391c11.992 29.912 11.93 64.124 7.385 109.239Z'
			fill='#E1DEE8'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M350.095 308.468c1.818 8.139 3.744 15.302 5.762 20.899l15.053 2.654c10.862-52.13-1.851-95.958-14.154-123.202 3.73.386 7.327-.571 10.098-3.996 9.757-12.061 8.382-19.891.901-23.704-4.114-2.097-8.364-1.91-13.451-1.686-4.163.182-8.886.39-14.555-.609l-.006-.001a9.992 9.992 0 0 0-1.522-.158l-6.785-.8s-43.592 87.724-36.817 120.821l55.476 9.782Z'
			fill='#F04248'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M350.095 308.468c-2.384-10.68-4.58-23.043-6.549-35.757-3.85 12.941-8.721 25.761-14.185 32.101l20.734 3.656Z'
			fill='#000'
			fillOpacity={0.1}
		/>
		<rect
			x={53.335}
			y={394.98}
			width={33.971}
			height={8.046}
			rx={2}
			fill='#B1ACC9'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M72.809 329.719c.463 13.784 2.614 26.896 6.452 39.335h5.81c7.653 0 13.857 6.204 13.857 13.857s-6.204 13.857-13.856 13.857H55.57c-7.653 0-13.857-6.204-13.857-13.857s6.204-13.857 13.857-13.857h6.705c5.757-18.659 6.452-39.335 6.452-39.335h4.082Z'
			fill='#DFDDE9'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M38.694 267.747s15.366-1.501 30.733-1.501c15.366 0 30.733 1.501 30.733 1.501l4.132 71.031s-17.433 1.669-34.865 1.669c-17.433 0-34.866-1.669-34.866-1.669l4.133-71.031Z'
			fill='#CAC5D6'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M106.974 403.026h18.774V496h-18.774v-73.307h-74.2V496H14v-92.974h92.974Z'
			fill='#DBD8E4'
		/>
		<g clipPath='url(#z)'>
			<rect x={756} width={131} height={54} rx={4} fill='#fff' />
			<g clipPath='url(#A)' fill='#DFDDE9'>
				<rect x={795} y={16.2} width={73} height={8.1} rx={3} />
				<rect x={795} y={29.7} width={49} height={8.1} rx={3} />
			</g>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M777 39c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z'
				fill='#CAC5D6'
			/>
		</g>
		<g clipPath='url(#B)'>
			<rect x={809} y={65} width={131} height={42} rx={4} fill='#fff' />
			<g clipPath='url(#C)' fill='#DFDDE9'>
				<rect x={848} y={77.6} width={73} height={6.3} rx={3} />
				<rect x={848} y={88.1} width={49} height={6.3} rx={3} />
			</g>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M830 98c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z'
				fill='#CAC5D6'
			/>
		</g>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M129.111 298.27c15.235 25.559 32.979 50.307 43.635 78.252a407.282 407.282 0 0 0-1.394-9.87c-2.704-17.418-6.064-34.708-9.595-51.978-1.799-8.793-3.701-17.554-5.651-26.314-1.05-4.705-2.086-9.413-3.157-14.114-.259-1.139-.482-3.127-.806-5.143 10.355 33.983 20.342 67.991 27.647 102.791a228.472 228.472 0 0 1 2.443 13.677c.228-1.038.453-2.076.699-3.112 2.956-12.411 7.39-24.724 12.669-36.33 2.523-5.55 5.422-10.978 8.835-16.036 2.129-3.153 7.148-6.901 9.089-10.13-10.618 19.475-14.452 43.842-20.583 65.015-1.496 5.167-3.002 10.326-4.478 15.493 9.246-18.542 23.591-33.777 43.536-40.379-24.142 15.952-38.623 43.887-48.381 72.458-.032.339-.071.678-.104 1.017 2.872-5.449 6.489-10.378 11.391-13.831 10.492-7.39 22.131-5.237 32.309 1.102-7.988-5.077-22.424-.454-29.145 4.707-4.812 3.694-8.923 8.65-12.494 13.486-.856 1.159-2.023 2.511-3.256 3.954a178.272 178.272 0 0 1-8.536 33.427c.658-3.174.182-8.25.365-10.616.02-.256.036-.512.056-.768a724.126 724.126 0 0 0-1.757 7.17c1.122-4.494 1.731-9.185 2.207-13.925.122-2.037.242-4.073.368-6.11-.04-3.866-.199-7.746-.468-11.633-.955-3.778-2.024-7.341-2.906-10.305-3.181-10.692-7.845-20.936-13.586-30.492-5.237-8.721-11.507-16.62-18.744-23.764-3.902-3.85-7.985-7.517-12.011-11.235-1.456-1.344-4.058-4.649-6.308-6.371 16.389 9.035 33.258 18.81 45.214 33.369a362.376 362.376 0 0 0-4.534-15.89c-8.171-26.383-18.487-53.726-32.569-77.572Z'
			fill='#BAB4CB'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M145.485 442.949c0 29.299 2.321 53.051 33.464 53.051 31.143 0 33.463-23.752 33.463-53.051'
			fill='#DBD8E4'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M765.698 248.144c-5.785 3.483-11.469 5.166-14.137 4.479-6.691-1.722-7.306-26.171-2.129-35.809 5.177-9.639 31.789-13.84 33.131 5.257.465 6.628-2.321 12.543-6.437 17.369l7.381 34.364h-21.44l3.631-25.66Z'
			fill='#B28B67'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M739.934 203.452c.444-1.559 1.638-2.894 3.247-3.29.39-.096.793-.134 1.195-.118.144.005.184.047.252-.054.05-.074.051-.257.071-.344.064-.273.144-.542.243-.804.337-.895.903-1.686 1.585-2.353 1.276-1.248 3-2.109 4.791-2.264.98-.086 1.954.073 2.881.392.479.165.945.37 1.398.597.136.069.579.403.716.382.151-.024.455-.4.578-.494 1.52-1.165 3.397-1.623 5.29-1.609 2.137.016 4.194.123 5.977 1.424a11.813 11.813 0 0 1 1.599 1.416c.101.109.199.22.293.335.159.194.134.258.357.122.858-.52 1.852-.764 2.853-.641a6.415 6.415 0 0 1 1.722.486c.187.08.62.399.819.402.198.003.624-.293.828-.368a6.808 6.808 0 0 1 3.442-.318 8.899 8.899 0 0 1 3.374 1.326c.486.316.91.666 1.25 1.135.148.203.28.418.447.606.098.11.291.223.343.362-.031-.083 1.304-.597 1.431-.63a3.519 3.519 0 0 1 2.012.076c1.236.407 2.3 1.318 3.173 2.252.449.48.842 1.011 1.175 1.576.16.271.306.549.44.834.065.137.108.31.193.434.11.16.184.163.383.233a6.192 6.192 0 0 1 2.637 1.763 6.065 6.065 0 0 1 1.364 2.891c.012.062.018.322.055.355.05.047.254.026.331.036.266.031.531.077.792.139.482.114.95.281 1.393.5 1.728.854 2.964 2.455 3.568 4.256.635 1.891.624 4.057-.135 5.912a5.76 5.76 0 0 1-.439.865c-.105.169-.139.17-.071.347.076.197.215.389.305.581.295.629.501 1.296.631 1.976.214 1.117.32 2.291.109 3.417a4.944 4.944 0 0 1-.528 1.499 4.399 4.399 0 0 1-.752.981c-.057.056-.133.106-.182.169-.12.154-.145.027-.083.253.086.316.282.628.402.935.124.317.235.638.338.963.207.656.382 1.325.491 2.005.211 1.306.174 2.697-.445 3.895a3.88 3.88 0 0 1-1.103 1.312 4.086 4.086 0 0 1-.725.44c-.132.062-.299.089-.359.216-.065.137.031.408.053.56.19 1.329.285 2.723-.11 4.024a5.558 5.558 0 0 1-2.206 2.958c-2.019 1.359-4.74 1.283-6.861.195a7.204 7.204 0 0 1-1.531-1.052c-1.175 1.58-3.593 1.53-5.31 1.08-2.139-.561-3.856-2.047-4.845-3.999-1.353 1.644-4.191 1.111-5.129-.673a4.28 4.28 0 0 1-.432-1.405c-.036-.256-.013-.515-.04-.769-.033-.323-.25-.638-.374-.951-.243-.61-.393-1.239-.4-1.897-.003-.343.04-.677.073-1.018.03-.306-.056-.592-.104-.894.549.09 1.217-.058 1.734-.217.507-.156.983-.566 1.341-.942.831-.871 1.339-2.013 1.686-3.149.763-2.494.45-5.487-2.061-6.856-1.171-.638-4.676-.636-6.069-.32-1.466.331-3.127 3.561-3.209 3.864-.05.188-.025.421-.197.546-.38.275-1.006-.203-1.287-.438-.483-.407-.828-.949-1.126-1.497a18.528 18.528 0 0 1-1.546-3.787c-.285-1.009-.468-2.049-.841-3.032-.372-.979-.957-1.853-1.868-2.408-.99-.603-2.126-.92-3.213-1.299-1.078-.376-2.137-.835-2.973-1.631a4.223 4.223 0 0 1-.51-.568c-.116-.163-.232-.475-.41-.578-.276-.161-.68.257-.919.409-1.179.748-2.163 1.792-2.957 2.932-.789 1.134-1.437 2.225-1.963 3.491-.391.939-.634 2.142-1.321 2.912-.307.343-2.585.551-3.323.251-.738-.3-1.565-1.079-1.813-1.567a2.44 2.44 0 0 1-.206-1.596c.064-.322.194-.622.265-.938.06-.266.115-.517.244-.76a1.876 1.876 0 0 1 1.17-.931 5.467 5.467 0 0 1-1.263-1.711c-.314-.673-.579-1.491-.654-2.229-.062-.6.033-1.221.362-1.737.344-.54.955-.893 1.484-1.23a9.649 9.649 0 0 1-2.067-2.248c-1.104-1.652-1.787-3.735-1.226-5.704Z'
			fill='#191847'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M841.653 385.348c8.837 0 16 7.164 16 16V480c0 8.837-7.163 16-16 16h-99.32c-8.836 0-16-7.163-16-16v-78.652c0-8.836 7.164-16 16-16h99.32Zm-13.013 24.986a4 4 0 0 1 4 4v52.68a4 4 0 0 1-4 4h-73.293a4 4 0 0 1-4-4v-52.68a4 4 0 0 1 4-4h73.293Z'
			fill='#CBC5D6'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M685.498 434.053c-3.322 11.626-11.6 33.661-23.046 58.966l-10.877-3.17c9.516-58.23 17.435-96.781 21.971-108.515 2.997-7.752 25.672-6.844 23.063 8.755-1.094 6.542-5.422 24.058-11.111 43.964Zm44.706-41.243c17.737 3.67 54.514 16.647 65.016 20.793 6.6 2.606 2.345 11.444-3.285 10.671-.954-.131-4.327-.508-9.361-1.07-16.167-1.807-49.462-5.528-74.713-9.158-13.297-1.911-6.144-26.79 7.661-24.157 4.645.886 9.585 1.866 14.682 2.921Z'
			fill='#B28B67'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M672.851 374.763c1.813-5.911 84.247-26.893 84.247-26.893h6.755v6.288l-56.804 28.885c.075.932.029 1.917-.154 2.956.41 21.413-8.765 37.411-17.849 53.249-5.94 10.357-11.841 20.647-14.997 32.338l-20.87-3.11c.608-1.553 1.569-8.555 2.883-18.13 3.314-24.141 8.873-64.633 16.671-75.346l.083-.112c.01-.041.022-.083.035-.125Z'
			fill='#1C2D4A'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M759.134 400.198c5.197-1.04 9.983-1.967 14.079-2.685 26.455-4.635 34.169-18.78 29.608-49.643h-48.742c-7.963 2.284-49.341 19.618-70.81 28.837-14.21 6.102-9.73 28.099-1.684 33.823.044.351.189.59.447.697 30.508 12.63 56.524 11.688 73.23 11.083 6.997-.254 12.361-.448 15.738.439l5.291-16.673-17.157-5.878Z'
			fill='#294370'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M789.636 412.974c.053-1.17 1.041-2.107 2.205-1.978 1.887.208 4.52.596 5.828 1.234 2.172 1.058 5.985 3.811 5.985 3.811l-22.087 45.236s-6.697-1.08-5.307-5.105c1.389-4.026 2.241-6.722 2.241-6.722l.879-25.486a1 1 0 0 1 1.063-.964l3.832.241s3.36-2.717 4.433-4.916c.625-1.28.85-3.619.928-5.351ZM664.973 487.422c1.074-.464 2.347.011 2.742 1.113.64 1.786 1.445 4.32 1.445 5.775 0 2.413-.805 7.044-.805 7.044h-50.386s-1.964-6.486 2.268-7.003c4.231-.517 7.03-.934 7.03-.934l23.319-10.384a.999.999 0 0 1 1.331.532l1.464 3.546s3.917 1.826 6.366 1.826c1.427 0 3.633-.826 5.226-1.515Z'
			fill='#E4E4E4'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M686.694 358.362 712 333.701l8.405 14.528-26.315 15.498c-6.598 10.382-10.473 14.868-11.626 13.458-.971-1.189-.526-2.493-.116-3.693.32-.935.618-1.808.208-2.516-.935-1.617-6.218-.691-11.194.402-4.976 1.092-3.825-1.349-2.767-2.624 4.703-3.791 10.736-7.255 18.099-10.392Zm149.164 35.828c-2.618-5.305-11.533-57.011-11.533-57.011l-18.668.074s17.29 55.754 18.668 59.166c1.79 4.431-1.251 10.87-3.313 15.236a102.77 102.77 0 0 0-.865 1.862c2.861 1.279 4.235-.267 5.684-1.896 1.637-1.841 3.369-3.788 7.445-1.894 1.575.732 3.065 1.597 4.521 2.443 5.03 2.92 9.65 5.603 15.935 1.729.997-.614 2.089-2.927-.549-4.734-6.573-4.502-16.045-12.381-17.325-14.975Z'
			fill='#B28B67'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='m771.273 258.931-7.725-1.324c-13.3 33.187-36.519 63.342-69.659 90.464l25.042 30.39c33.136-38.618 53.561-78.462 52.342-119.53Z'
			fill='#C46EB1'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M804.947 355.901H736.16s23.905-58.059 23.905-98.64l20.749-3.088c16.307 26.198 20.912 58.453 24.133 101.728Z'
			fill='#E0DEE8'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M836.213 385.348c-7.522-84.777-54.943-131.175-54.943-131.175l-.017.015a.11.11 0 0 0-.008-.015h-1.354c-2.431.083-7.406.301-7.406.301l-5.014 14.313c-.795 26.175-9.291 105.502-9.291 105.502h45.025a213.67 213.67 0 0 1-.519 11.059h33.527Z'
			fill='#E9C9E4'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M803.197 374.64c.36-15.839-1.047-30.711-3.394-44.169-1.227 15.97-3.792 35.186-9.15 44.169h12.544Z'
			fill='#000'
			fillOpacity={0.1}
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M793.234 346.977 771 336.652v10.325h22.234Z'
			fill='#fff'
			fillOpacity={0.2}
		/>
		<defs>
			<clipPath id='a'>
				<path fill='#fff' transform='translate(399 19)' d='M0 0h329v339H0z' />
			</clipPath>
			<clipPath id='b'>
				<path
					fill='#fff'
					transform='translate(643.54 148.329)'
					d='M0 0h68.746v190.075H0z'
				/>
			</clipPath>
			<clipPath id='c'>
				<path
					fill='#fff'
					transform='translate(661.54 166.329)'
					d='M0 0h33v158H0z'
				/>
			</clipPath>
			<clipPath id='d'>
				<path fill='#fff' transform='translate(415 63)' d='M0 0h219v282H0z' />
			</clipPath>
			<clipPath id='e'>
				<path fill='#fff' transform='translate(415 63)' d='M0 0h219v47H0z' />
			</clipPath>
			<clipPath id='f'>
				<path
					fill='#fff'
					transform='translate(424 77.1)'
					d='M0 0h161v18.8H0z'
				/>
			</clipPath>
			<clipPath id='g'>
				<path fill='#fff' transform='translate(415 118)' d='M0 0h219v39H0z' />
			</clipPath>
			<clipPath id='h'>
				<path
					fill='#fff'
					transform='translate(424 129.7)'
					d='M0 0h161v15.6H0z'
				/>
			</clipPath>
			<clipPath id='i'>
				<path fill='#fff' transform='translate(415 165)' d='M0 0h219v39H0z' />
			</clipPath>
			<clipPath id='j'>
				<path
					fill='#fff'
					transform='translate(424 176.7)'
					d='M0 0h161v15.6H0z'
				/>
			</clipPath>
			<clipPath id='k'>
				<path fill='#fff' transform='translate(415 306)' d='M0 0h219v39H0z' />
			</clipPath>
			<clipPath id='l'>
				<path
					fill='#fff'
					transform='translate(424 317.7)'
					d='M0 0h161v15.6H0z'
				/>
			</clipPath>
			<clipPath id='m'>
				<path fill='#fff' transform='translate(415 259)' d='M0 0h219v39H0z' />
			</clipPath>
			<clipPath id='n'>
				<path
					fill='#fff'
					transform='translate(424 270.7)'
					d='M0 0h161v15.6H0z'
				/>
			</clipPath>
			<clipPath id='o'>
				<path fill='#fff' transform='translate(415 212)' d='M0 0h219v39H0z' />
			</clipPath>
			<clipPath id='p'>
				<path
					fill='#fff'
					transform='translate(424 223.7)'
					d='M0 0h161v15.6H0z'
				/>
			</clipPath>
			<clipPath id='q'>
				<path fill='#fff' transform='translate(62 9)' d='M0 0h223v325H0z' />
			</clipPath>
			<clipPath id='r'>
				<path fill='#fff' transform='translate(133 62)' d='M0 0h123v231H0z' />
			</clipPath>
			<clipPath id='s'>
				<path
					fill='#fff'
					transform='translate(142 80.344)'
					d='M0 0h65v24.459H0z'
				/>
			</clipPath>
			<clipPath id='t'>
				<path
					fill='#fff'
					transform='translate(133 132.206)'
					d='M0 0h123v47.559H0z'
				/>
			</clipPath>
			<clipPath id='u'>
				<path
					fill='#fff'
					transform='translate(172 146.474)'
					d='M0 0h65v19.023H0z'
				/>
			</clipPath>
			<clipPath id='v'>
				<path
					fill='#fff'
					transform='translate(133 188.823)'
					d='M0 0h123v47.559H0z'
				/>
			</clipPath>
			<clipPath id='w'>
				<path
					fill='#fff'
					transform='translate(142 203.091)'
					d='M0 0h65v19.023H0z'
				/>
			</clipPath>
			<clipPath id='x'>
				<path
					fill='#fff'
					transform='translate(133 245.441)'
					d='M0 0h123v47.559H0z'
				/>
			</clipPath>
			<clipPath id='y'>
				<path
					fill='#fff'
					transform='translate(172 259.709)'
					d='M0 0h65v19.023H0z'
				/>
			</clipPath>
			<clipPath id='z'>
				<path fill='#fff' transform='translate(756)' d='M0 0h131v54H0z' />
			</clipPath>
			<clipPath id='A'>
				<path fill='#fff' transform='translate(795 16.2)' d='M0 0h73v21.6H0z' />
			</clipPath>
			<clipPath id='B'>
				<path fill='#fff' transform='translate(809 65)' d='M0 0h131v42H0z' />
			</clipPath>
			<clipPath id='C'>
				<path fill='#fff' transform='translate(848 77.6)' d='M0 0h73v16.8H0z' />
			</clipPath>
		</defs>
	</StyledSvg>
)
